import { Panel, RoutedPanelProps } from '@/components/Layout/Panel/Panel';
import { ticketsCrossProjectTableConfig } from '@/config/table-configs';
import { TicketTable } from '@/features/tickets/ticket.table';
import { useTickets } from '@/features/tickets/tickets.hooks';

export function AllTicketsPanel({ basePath, ...panelProps }: RoutedPanelProps) {
  const res = useTickets();
  return (
    <Panel {...panelProps} title="All tickets">
      <TicketTable
        uriPrefix={basePath}
        tableId="all-tickets"
        defaultConfig={ticketsCrossProjectTableConfig}
        {...res}
      />
    </Panel>
  );
}
